import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group/children-tile relative z-0 grid grid-cols-[60px_1fr_auto] gap-[14px]',
    link: 'absolute inset-0 z-10 cursor-pointer',
    imageContainer: 'bg-accent relative size-[60px]',
    image: 'size-full object-contain',
    content: 'flex flex-1 flex-col gap-3 max-md:col-start-2 max-md:row-start-1',
    title: 'heading-xs-bold line-clamp-2 leading-tight',
    priceRow: 'flex items-center gap-3',
    actions:
      'max-md:align-self-end relative z-20 flex flex-col items-center justify-end md:pl-4',
    actionItem:
      'link transition-opacity md:opacity-0 md:group-hover/children-tile:opacity-100'
  },
  variants: {
    isInWishlist: {
      true: {
        actionItem: '!opacity-100'
      }
    }
  }
});
